import Routes from './routes';
import { assignmentTypes } from './shared/authorization/assignmentTypes';
import assignmentPermissions from './shared/authorization/assignmentPermissions';
import permissionTypes from './shared/authorization/permissionTypes';
import permissions from './shared/authorization/permissionPaths';


export const routesPermissions = {
  [Routes.provision.BATCH_ADJUSTMENTS]: {
    withAssignments: [{
      assignmentType: assignmentTypes.COMPANY_CODES,
      requiredPermission: assignmentPermissions.Adjust,
    }],
  },
  [Routes.provision.BATCH_PROVISIONS]: {
    withPermissions: [{
      permissionType: permissionTypes.VIEW,
      permissionPath: permissions.BATCH_PROVISION,
    }],
  },
  [Routes.balanceSheetManagement.ADD_TAX_ENTRY]: {
    withPermissions: [{
      permissionType: permissionTypes.VIEW,
      permissionPath: permissions.ADD_TAX_ENTRY,
    }],
  },
  [Routes.balanceSheetManagement.BATCH_TAX_ENTRIES]: {
    withPermissions: [{
      permissionType: permissionTypes.VIEW,
      permissionPath: permissions.BATCH_TAX_ENTRIES,
    }],
  },
  [Routes.balanceSheetManagement.RATE_CHANGE_WORKPAPER]: {
    withPermissions: [{
      permissionType: permissionTypes.VIEW,
      permissionPath: permissions.BATCH_RATE_CHANGE_WORKPAPER,
    }],
  },
  [Routes.reports.CUSTOM_REPORT]: {
    withPermissions: [{
      permissionType: permissionTypes.VIEW,
      permissionPath: permissions.CUSTOM_REPORTS,
    }],
  },
  [Routes.reports.CUSTOM_REPORTS]: {
    withPermissions: [{
      permissionType: permissionTypes.VIEW,
      permissionPath: permissions.CUSTOM_REPORTS,
    }],
  },
  [Routes.reports.BATCH_REPORTS]: {
    withPermissions: [{
      permissionType: permissionTypes.VIEW,
      permissionPath: permissions.CUSTOM_REPORTS,
    }],
  },
  [Routes.administration.DATABASE_LOGS]: {
    withPermissions: [{
      permissionType: permissionTypes.VIEW,
      permissionPath: permissions.DATABASE_LOGS,
    }],
  },
  [Routes.administration.COMMUNICATIONS_MANAGEMENT]: {
    withPermissions: [{
      permissionType: permissionTypes.MODIFY,
      permissionPath: permissions.COMMUNICATIONS,
    }],
  },
  [Routes.administration.NOL_AND_VA]: {
    withPermissions: [{
      permissionType: permissionTypes.VIEW,
      permissionPath: permissions.NOL_VA,
    }],
  },
  [Routes.administration.CUSTOM_REPORTS_MANAGEMENT]: {
    withPermissions: [{
      permissionType: permissionTypes.VIEW,
      permissionPath: permissions.CUSTOM_REPORTS_MANAGEMENT,
    }],
  },
  [Routes.administration.APPLICATION_SETTINGS]: {
    withPermissions: [{
      permissionType: permissionTypes.VIEW,
      permissionPath: permissions.APPLICATION_SETTINGS,
    }],
  },
  [Routes.administration.E2E_HEALTHCHECK]: {
    withPermissions: [{
      permissionType: permissionTypes.VIEW,
      permissionPath: permissions.E2E_HEALTHCHECK,
    }],
  },
  [Routes.administration.ADMIN_IMPORT]: {
    withPermissions: [{
      permissionType: permissionTypes.VIEW,
      permissionPath: permissions.APPLICATION_SETTINGS,
    }],
  },
  [Routes.administration.CUSTOM_GROUPS]: {
    withPermissions: [{
      permissionType: permissionTypes.VIEW,
      permissionPath: permissions.CUSTOM_GROUPS,
    }],
  },
  [Routes.administration.CLIENT_ADMINISTRATION]: {
    withPermissions: [{
      permissionType: permissionTypes.VIEW,
      permissionPath: permissions.CLIENT_ADMININISTRATION,
    }],
  },
  [Routes.administration.USER_SETTINGS]: {
    withPermissions: [{
      permissionType: permissionTypes.VIEW,
      permissionPath: permissions.USER_ADMINISTRATION,
    }],
  },
  [Routes.administration.USER_EXPIRATION]: {
    withPermissions: [{
      permissionType: permissionTypes.VIEW,
      permissionPath: permissions.USER_ADMINISTRATION,
    }],
  },
  [Routes.administration.ROLES]: {
    withPermissions: [{
      permissionType: permissionTypes.VIEW,
      permissionPath: permissions.USER_ADMINISTRATION,
    }],
  },
  [Routes.administration.ADMIN_TAX_ENTRY]: {
    withPermissions: [{
      permissionType: permissionTypes.VIEW,
      permissionPath: permissions.ADMIN_TAX_ENTRY,
    }],
  },
  [Routes.administration.GL_ACCOUNT_LIST]: {
    withPermissions: [{
      permissionType: permissionTypes.VIEW,
      permissionPath: permissions.GL_ACCOUNT_LIST_PAGE,
    }],
  },
  [Routes.administration.ACCOUNT_MAP]: {
    withPermissions: [{
      permissionType: permissionTypes.VIEW,
      permissionPath: permissions.ACCOUNT_MAP_PAGE,
    }],
  },
  [Routes.administration.DIAGNOSTICS]: {
    withPermissions: [{
      permissionType: permissionTypes.VIEW,
      permissionPath: permissions.DIAGNOSTICS,
    }],
  },
  [Routes.administration.TRIAL_BALANCE_THRESHOLD]: {
    withPermissions: [{
      permissionType: permissionTypes.VIEW,
      permissionPath: permissions.TRIAL_BALANCE_THRESHOLD,
    }],
  },
  [Routes.administration.SL_ACCOUNTS_PAGE]: {
    withPermissions: [{
      permissionType: permissionTypes.VIEW,
      permissionPath: permissions.SL_ACCOUNTS_PAGE,
    }],
  },
  [Routes.administration.GL_JOURNALS]: {
    withPermissions: [{
      permissionType: permissionTypes.VIEW,
      permissionPath: permissions.GL_JOURNALS_PAGE,
    }],
  },
  [Routes.administration.CLIENT]: {
    withPermissions: [{
      permissionType: permissionTypes.VIEW,
      permissionPath: permissions.CLIENT,
    }],
  },

} as const;
